<template>
  <div class="oss">
    <el-upload
      :before-remove="beforeRemove"
      :before-upload="beforeAvatarUpload"
      :file-list="fileList"
      :http-request="upload"
      :limit="limit"
      :on-exceed="handleExceed"
      :on-remove="handleRemove"
      :on-success="handleSuccess"
      action
      class="upload-demo"
    >
      <el-button size="small" type="primary">点击上传</el-button>
    </el-upload>
    <el-progress
      :percentage="progress"
      :stroke-width="15"
      :text-inside="true"
      v-show="showProgress"
    ></el-progress>
  </div>
</template>

<script>
let OSS = require("ali-oss");

import lrz from "lrz";
import qs from 'qs';


export default {
  name: "oss",
  data() {
    return {
      fileList: [], //文件列
      limit: 1, //最大上传文件数
      showProgress: false, //进度条的显示
      progress: 0 //进度条数据
    };
  },
  methods: {
    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      this.$emit("on-remove", file, fileList);
    },
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      this.fileList = fileList;
    },
    //文件上传前的校验
    beforeAvatarUpload(file) {
      const isLt100M =
        file.size / 1024 / 1024 > 0 && file.size / 1024 / 1024 < 1024;
      const isLt30 = file.name.length < 30;
      // if (file.type !== 'image/png') {
      //     this.$message.error("请上传PNG格式图片");
      //     return false;
      // }
      if (!isLt100M) {
        this.$message.error("上传大小要在0MB~1GB之间哦!");
        return false;
      }
      if (!isLt30) {
        this.$message.error("上文件名稱长度必须要小于30个文字哦!");
        return false;
      }
    },
    //覆盖默认的上传行为，自定义上传的实现
    upload(file) {
      var self = this;
      this.$http.get("/admin/oss").then(res => {
        if (res.code == 200) {
          // self.ossupload(file, res.data);
          self.oss_compress_upload(file, res.data);
        }
      });
    },
    /**
     * 获取随机字符串
     * @param {*} len 长度
     */
    randomString(len) {
        len = len || 32
        const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
        const maxPos = chars.length
        let pwd = ''
        for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
        }
        return pwd
    },
    getObjectKey(dir, file) {
        return `${dir}${this.randomString(
        8
        )}_${new Date().getTime()}.${file.name.split('.').pop()}`
    },
    //base64转blob
    dataURL2blob(dataURL) {
      let binaryString = atob(dataURL.split(",")[1]);
      let arrayBuffer = new ArrayBuffer(binaryString.length);
      let intArray = new Uint8Array(arrayBuffer);
      let mime = dataURL.split(",")[0].match(/:(.*?);/)[1];
      for (let i = 0, j = binaryString.length; i < j; i++) {
        intArray[i] = binaryString.charCodeAt(i);
      }
      let data = [intArray];
      let result;
      try {
        result = new Blob(data, { type: mime });
      } catch (error) {
        window.BlobBuilder =
          window.BlobBuilder ||
          window.WebKitBlobBuilder ||
          window.MozBlobBuilder ||
          window.MSBlobBuilder;
        if (error.name === "TypeError" && window.BlobBuilder) {
          var builder = new BlobBuilder();
          builder.append(arrayBuffer);
          result = builder.getBlob(type);
        } else {
          throw new Error("没救了");
        }
      }
      return result;
    },
    //压缩上传
    async oss_compress_upload(file,params){
        let result = await lrz(file.file, { width: 750 });
        const self = this;
        let client = new OSS({
          region: params.region,
          accessKeyId: params.accessKeyId,
          accessKeySecret: params.accessKeySecret,
          bucket: params.bucket,
          secure: true
        });

        let file_name = self.getObjectKey('images/',file.file);
        
        let to_blob = self.dataURL2blob(result.base64);

        let reader = new FileReader();
        reader.readAsArrayBuffer(to_blob);
        reader.onload = function(event)
        {
          let buffer = new OSS.Buffer(event.target.result);
          client.put(file_name,buffer).then(res=>{
            console.log("res:",res);
          })
        }
    },
    //上传
    ossupload(file, params) {
      const self = this;

      let client = new OSS({
        region: params.region,
        accessKeyId: params.accessKeyId,
        accessKeySecret: params.accessKeySecret,
        bucket: params.bucket,
        secure: true
      });

      let file_name = self.getObjectKey('images/',file.file);

      

      client
        .multipartUpload(file_name, file.file, {
          progress: function(p) {
            //p进度条的值
            self.showProgress = true;
            self.progress = Math.floor(p * 100);
          }
        })
        .then(result => {
          //上传成功返回值，可针对项目需求写其他逻辑
          self.$message({
            message: "文件上传成功",
            type: "success"
          });
          console.log(result);
        })
        .catch(err => {
          self.$message.error("上传失败，请重试。");
          console.log("err:", err);
        });
    }
  }
};
</script>